import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ForgetForm from "../../components/auth-form/ForgetForm";
import LoginForm from "../../components/auth-form/LoginForm";
import OtpVerificatioForm from "../../components/auth-form/OtpVerificatioForm";
import ResetForm from "../../components/auth-form/ResetForm";
import Home from "../../components/Home";
import NewLayout from "../../layout/DashbordLayout";
import Layout from "../../layout/Layout";
// import ITInForm from "../../pages/itin/ITInForm";
import ApplyDetail from "../../components/itin/ApplyDetail";
import { FormPage } from "../../pages/itin/FormPage";
import ProtectedRoute from "../../utils/ProtectedRoute";
import { getToken } from "../../utils/StorageUtils";
import LlcDetail from "../../components/ss4container/LlcDetail";
import SS4Form from "../../pages/IntechTechnology/SS4Form";
import AdminLayout from "../../layout/AdminLayout";
import AdminDashboard from "../../pages/adminDashboard/AdminDashboard";
import Agents from "../../pages/agents/Agents";
import Itin from "../../pages/itin/Itin";
import Client from "../../pages/clients/Client";
import LlcEinOrders from "../../pages/incorporation/LlcEinOrders";
import Incorporation from "../../pages/incorporation/Incorporation";
import Orders from "../../pages/orders/Orders";
import Services from "../../pages/services/Services";
import OrderDetails from "../../pages/orders/OrderDetails";
import ClientDetail from "../../pages/clients/ClientDetail";
import RoleProtectedRoute from "../../utils/RoleProtectedRoute";
import AddEditService from "../../pages/services/AddEditService";
import Invoices from "../../pages/Tools/Invoices";
import AddCustomerInfo from "../../components/invoices/AddCustomerInfo";
import NoInvoicePage from "../../components/invoices/NoInvoicePage";
import InvoiceForm from "../../components/invoices/InvoiceForm";
import OperatingAgreement from "../../pages/Tools/OperatingAgreement";
import { Bookkeeper } from "../../pages/Tools/Bookkeeper";
import { SetupBookkeeper } from "../../components/Bookkeeper/SetupBookkeeper";
import BookkeeperData from "../../components/Bookkeeper/BookkeeperData";
import InvoicePlanPage from "../../components/invoices/InvoicePlanPage";
import CustomInvoiceForm from "../../components/invoices/CustomInvoiceForm";
import ViewCustomImvoice from "../../components/invoices/ViewCustomInvoice";
import TaxFilling from "../../components/taxfiling/TaxFilling";
import TaxFilingOrder from "../../pages/Tools/TaxFilingOrder";
import SingleMember from "../../pages/orderMember/singleMember";
import CCorpMemberForm from "../../components/taxfiling/CCorpMemberForm";
import MultimemberForm from "../../components/taxfiling/MultimemberForm";
import TaxReviewPage from "../../components/taxfiling/TaxPageReview";
import TaxFillingDetailOrder from "../../components/taxfiling/TaxFillingDetailOrder";
import TaxReviewPageCcrop from "../../components/taxfiling/TaxPageReviewCcrop";
import MultimemberPageReview from "../../components/taxfiling/MultimemberPageReview";
import OperatingAgreementDetails from "../../pages/orders/OperatingAgreementDetails";
import Bpp from "../../pages/bpp/Bpp";
import BookkeepingRules from "../../components/Bookkeeper/components/BookkeepingRules";
import OperatingAgreementTable from "../../components/tools/OperatingAgreementTable";
import Subscriptions from "../../pages/subscriptions";
import OAStepThree from "../../components/tools/os-step-three";
import OAStepTwo from "../../components/tools/oa-step-two";
import AdminInvoices from "../../pages/AdminInvoices/AdminInvoices";
import CreateInvoice from "../../pages/AdminInvoices/CreateInvoice";
import PayInvoice from "../../pages/AdminInvoices/PayInvoice";
// import TaxFillingNew from "../../pages/Tools/TaxFillingNew";

const Index = () => {
  const token = getToken();

  const roleId = Number(localStorage.getItem("roleId"));
  return (
    <BrowserRouter>
      <Routes>
        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route
            path="*"
            element={
              token && roleId ? (
                roleId === 1 ? (
                  <Navigate to="/admin-dashboard" replace />
                ) : (
                  <Navigate to="/dashboard" replace />
                )
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          {/* Admin Routes */}
          <Route
            element={
              <RoleProtectedRoute allowedRoles={[1]} userRoleId={roleId} />
            }
          >
            <Route element={<AdminLayout />}>
              <Route path="/admin-dashboard" element={<AdminDashboard />} />
              <Route path="/admin-orders" element={<Orders />} />
              <Route
                path="/admin-orders-operating-agreement/:id?"
                element={<OperatingAgreementDetails />}
              />
              <Route path="/admin-orders/:id" element={<OrderDetails />} />
              <Route path="/admin-clients" element={<Client />} />
              <Route path="/admin-clients/:id" element={<ClientDetail />} />
              <Route path="/admin-services" element={<Services />} />
              <Route
                path="/admin-services/create"
                id={`createService`}
                element={<AddEditService key={`createService`} />}
              />
              <Route
                path="/admin-services/:id"
                id={`editService`}
                element={<AddEditService key={`editService`} />}
              />
              <Route path="/admin-agents" element={<Agents />} />
              <Route path="/admin-invoices" element={<AdminInvoices />} />
              <Route
                path="/admin-invoices/createInvoice/:id?"
                element={<CreateInvoice />}
              />
            </Route>
          </Route>
        </Route>

        {/* PUBLIC ROUTE */}
        <Route
          path="/view-custom-invoice/:invoice_id"
          element={<ViewCustomImvoice />}
        />
        <Route path="/admin/invoices/pay/:token" element={<PayInvoice />} />
        {roleId === 2 && (
          <Route element={<NewLayout />}>
            <Route path="/dashboard" element={<Home />} />
            <Route path={"/itin"} element={<Itin />} />
            <Route path={"/subscriptions"} element={<Subscriptions />} />
            {/*<Route path={"/itin/:page"} element={<FormPage />} />*/}
            <Route path={"/tools/invoices"} element={<InvoicePlanPage />} />
            <Route
              path={"/tools/operating-agreement"}
              element={<OperatingAgreement />}
            />
            <Route
              path={"/tools/operating-agreement/list"}
              element={<OperatingAgreementTable />}
            />
            <Route
              path={"/tools/operating-agreement/uploads/:id?"}
              element={<OAStepTwo />}
            />
            <Route
              path={"/tools/operating-agreement/:id"}
              element={<OAStepThree />}
            />
            <Route
              path={"/tools/invoices/customerInfo"}
              element={<AddCustomerInfo />}
            />
            <Route
              path={"/tools/invoices/custom-invoice-form"}
              element={<CustomInvoiceForm />}
            />
            <Route
              path={"/tools/invoices/no-invoice"}
              element={<NoInvoicePage setPage={() => {}} />}
            />
            <Route path={"/tools/invoices/setup"} element={<Invoices />} />
            <Route
              path={"/tools/invoices/settings"}
              element={<InvoiceForm setPage={() => {}} />}
            />
            <Route path={"/tools/bookkeeper"} element={<Bookkeeper />} />
            <Route
              path={"/tools/tax-filing/list"}
              element={<TaxFilingOrder />}
            />
            <Route path={"/tools/tax-filing"} element={<TaxFilling />} />
            <Route
              path={"/tools/tax-filing/single-member/:id?"}
              element={<SingleMember />}
            />
            <Route
              path={"/tools/tax-filing/review/:id?"}
              element={<TaxReviewPage />}
            />
            <Route
              path={"/tools/tax-filing/multimember-review/:id?"}
              element={<MultimemberPageReview />}
            />
            <Route
              path={"/tools/tax-filing/review-ccrop/:id?"}
              element={<TaxReviewPageCcrop />}
            />
            <Route
              path={"/tools/tax-filing/corp-member/:id?"}
              element={<CCorpMemberForm />}
            />
            <Route
              path={"/tools/tax-filing/multimember/:id"}
              element={<MultimemberForm />}
            />
            <Route
              path={"/tools/tax-filing/multimember/:id?"}
              element={<MultimemberForm />}
            />
            <Route
              path={"/tools/tax-filing/tax-detail/:id/:orderId"}
              element={<TaxFillingDetailOrder />}
            />
            <Route
              path={"/tools/bookkeeper/setup"}
              element={<SetupBookkeeper />}
            />
            <Route
              path={"/tools/bookkeeper/dashboard"}
              element={<BookkeeperData />}
            />
            <Route
              path={"/tools/bookkeeper/rules"}
              element={<BookkeepingRules />}
            />
            <Route path={"/tools/bpp"} element={<Bpp />} />
            <Route
              path={"/itin/:id"}
              id={`itinHome`}
              element={<FormPage key={`itinHome`} />}
            />
            <Route
              path={"/itin/:id/edit-documents"}
              id={`editDoc`}
              element={<FormPage key={`editDoc`} />}
            />
            <Route
              path={"/itin/:id/edit-w7"}
              id={`w7form`}
              element={<FormPage key={`w7form`} />}
            />

            <Route path={"/itin-detail/:id"} element={<ApplyDetail />} />
            <Route path={"/incorporation-detail/:id"} element={<LlcDetail />} />
            <Route path={"/incorporation"} element={<LlcEinOrders />} />
            <Route path={"/incorporation/:id"} element={<Incorporation />} />
            <Route
              path={"/incorporation/:id/edit"}
              id={`edit`}
              element={<Incorporation key={`edit`} />}
            />

            <Route
              path={"/incorporation/:id/view"}
              id={`view`}
              element={<Incorporation key={`view`} />}
            />
            <Route path="/incorporation-detail/:id/ss4" element={<SS4Form />} />
            <Route
              path="/incorporation-detail/:id/ss4/edit"
              element={<SS4Form />}
            />
          </Route>
        )}
        <Route element={<Layout />}>
          {/* Redirect logged-in users to home */}
          <Route
            path="/login"
            element={
              token ? <Navigate to="/dashboard" replace /> : <LoginForm />
            }
          />
          <Route path="/forget-password" element={<ForgetForm />} />
          <Route path="/otp-verify" element={<OtpVerificatioForm />} />
          <Route path="/reset-password" element={<ResetForm />} />
          <Route path="/set-password/:token" element={<ResetForm />} />
        </Route>
        {/* Fallback Route */}
        <Route
          path="*"
          element={
            roleId === 1 ? (
              <Navigate to="/admin-dashboard" replace />
            ) : (
              <Navigate to="/dashboard" replace />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Index;
